import { QuestionnaireFormValues } from '~/pages/Auth/Questionnaire/QuestionnaireForm';
import RegisterUser from '~/types/RegisterUser';
import { User } from '~/types/User';
import { ActionKeys } from './constants';

interface ErrorObj {
  errorMessage: string;
}

export function register(payload: RegisterUser, next: string) {
  return <const>{
    payload,
    next,
    type: ActionKeys.REGISTER,
  };
}

export function registerSuccess(sessionToken: string, next: string) {
  return <const>{
    payload: { sessionToken, next },
    type: ActionKeys.REGISTER_SUCCESS,
  };
}

export function registerError(err: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  firstName?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lastName?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  email?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  password?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorMessage: any;
}) {
  return <const>{
    payload: { error: err },
    type: ActionKeys.REGISTER_ERROR,
  };
}

export function login(email: string, password: string) {
  return <const>{
    type: ActionKeys.LOGIN,
    payload: {
      email,
      password,
    },
  };
}

export function loginSuccess() {
  return <const>{
    type: ActionKeys.LOGIN_SUCCESS,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loginError(err: { email: any; password: any; errorMessage: any }) {
  return <const>{
    payload: { error: err },
    type: ActionKeys.LOGIN_ERROR,
  };
}

export function resetPassword(email: string) {
  return <const>{
    type: ActionKeys.RESET_PASSWORD,
    payload: {
      email,
    },
  };
}

export function resetPasswordSuccess() {
  return <const>{
    type: ActionKeys.RESET_PASSWORD_SUCCESS,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function resetPasswordError(err: { email?: any; errorMessage: any }) {
  return <const>{
    payload: { error: err },
    type: ActionKeys.RESET_PASSWORD_ERROR,
  };
}

export function resendVerification(withRedirect = true) {
  return <const>{
    type: ActionKeys.RESEND_VERIFICATION,
    payload: {
      withRedirect,
    },
  };
}

export function resendVerificationSuccess() {
  return <const>{
    type: ActionKeys.RESEND_VERIFICATION_SUCCESS,
  };
}

export function resendVerificationError(err: ErrorObj) {
  return <const>{
    payload: { error: err },
    type: ActionKeys.RESEND_VERIFICATION_ERROR,
  };
}

export function userDidAuthenticate(payload: { user: User }) {
  return <const>{
    type: ActionKeys.USER_DID_AUTHENTICATE,
    payload: { currentUser: payload.user },
  };
}

export function initializeAnonymousGTM() {
  return <const>{ type: ActionKeys.INITIALIZE_ANONYMOUS_TAG_MANAGER };
}

// TODO: Add types to params
export function sendRegisterQuestionnaire(payload: QuestionnaireFormValues) {
  return <const>{
    payload,
    type: ActionKeys.SEND_REGISTER_QUESTIONNAIRE,
  };
}

export function sendRegisterQuestionnaireSuccess() {
  return <const>{
    type: ActionKeys.SEND_REGISTER_QUESTIONNAIRE_SUCCESS,
  };
}

export function sendRegisterQuestionnaireError() {
  return <const>{
    type: ActionKeys.SEND_REGISTER_QUESTIONNAIRE_ERROR,
  };
}

export function finishRegister() {
  return <const>{
    type: ActionKeys.FINISH_REGISTER,
  };
}

export function clearAuthError() {
  return <const>{
    type: ActionKeys.RESET_AUTH_ERROR,
  };
}

export type AuthActions =
  | ReturnType<typeof register>
  | ReturnType<typeof registerSuccess>
  | ReturnType<typeof registerError>
  | ReturnType<typeof login>
  | ReturnType<typeof loginSuccess>
  | ReturnType<typeof loginError>
  | ReturnType<typeof resetPassword>
  | ReturnType<typeof resetPasswordSuccess>
  | ReturnType<typeof resetPasswordError>
  | ReturnType<typeof resendVerification>
  | ReturnType<typeof resendVerificationSuccess>
  | ReturnType<typeof resendVerificationError>
  | ReturnType<typeof userDidAuthenticate>
  | ReturnType<typeof initializeAnonymousGTM>
  | ReturnType<typeof sendRegisterQuestionnaire>
  | ReturnType<typeof sendRegisterQuestionnaireSuccess>
  | ReturnType<typeof sendRegisterQuestionnaireError>
  | ReturnType<typeof finishRegister>
  | ReturnType<typeof clearAuthError>;
